import React from 'react'
import VitalCard from './VitalCard'
import { ReactComponent as LungIcon } from '../../../../assets/icons/Lung.svg'
import { ReactComponent as HeartIcon } from '../../../../assets/icons/HeartBeat.svg'
import { ReactComponent as SkinIcon } from '../../../../assets/icons/BrightSkin.svg'
import { ReactComponent as BloodPressureIcon } from '../../../../assets/icons/BloodPressure.svg'
import { Box, Grid } from '@mui/material'
// import useCustomStyles from '../../../../utils/hooks/CustomStylesHook'
import ECGChart from './ECGChart'
import { useAppSelector } from '../../../../app/hooks'
import {
  selectProrithm,
  selectProrithmEcg,
  selectSafeRanges,
} from './DeviceSlice'
import { getIconColor, safeRangeKeys } from './Constant'
import { getLocalTimeFromEpoch } from '../../utils'

// const styles = () => ({
//   ecgContainer: {
//     border: '1px solid grey',
//     borderRadius: '11px',
//     margin: '10px',
//   },
// })

function Prorithm({
  setOpenDrawer,
  setSelectedVital,
}: {
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>
  setSelectedVital: React.Dispatch<React.SetStateAction<string>>
}) {
  // const theme = useTheme()
  // const classes = useCustomStyles(styles, theme)

  const ecgData = useAppSelector(selectProrithmEcg)
  const vitals: Record<string, any> = useAppSelector(selectProrithm)
  const safeRanges = useAppSelector(selectSafeRanges)

  const cardData = [
    {
      name: 'Heart Rate',
      subName: 'Current',
      value: `${vitals?.hr?.[0]?.v || '-'}`,
      unit: 'BPM',
      note: `Normal Range is ${safeRanges?.[safeRangeKeys?.HEARTRATE]?.min}-${
        safeRanges?.[safeRangeKeys?.HEARTRATE]?.max
      } BPM`,
      icon: (
        <HeartIcon
          height={40}
          width={40}
          color={getIconColor(
            safeRanges,
            safeRangeKeys?.HEARTRATE,
            vitals?.hr?.[0]?.v
          )}
        />
      ),
      time: vitals?.hr?.[0]?.t
        ? getLocalTimeFromEpoch(parseInt(vitals?.hr?.[0]?.t))
        : '-',
      details: false,
    },
    {
      name: 'Spo2',
      subName: 'Current',
      value: `${vitals?.spo2?.[0]?.v || '-'}`,
      unit: '%',
      note: `Normal Range is ${safeRanges?.[safeRangeKeys?.SPO2]?.min}-${
        safeRanges?.[safeRangeKeys?.SPO2]?.max
      } %`,
      icon: (
        <LungIcon
          height={40}
          width={40}
          color={getIconColor(
            safeRanges,
            safeRangeKeys?.SPO2,
            vitals?.spo2?.[0]?.v
          )}
        />
      ),
      time: vitals?.spo2?.[0]?.t
        ? getLocalTimeFromEpoch(parseInt(vitals?.spo2?.[0]?.t))
        : '-',
      details: false,
    },
    {
      name: 'Blood Pressure Systolic',
      subName: 'Hyper Tension',
      value: vitals?.bp?.[0]?.sp || '-',
      unit: 'mm Hg',
      note: `Normal Range is ${
        safeRanges?.[safeRangeKeys?.BLOODPRESSURESYSTOLIC]?.min
      }-${safeRanges?.[safeRangeKeys?.BLOODPRESSURESYSTOLIC]?.max} mmHg`,
      icon: (
        <BloodPressureIcon
          height={40}
          width={40}
          color={getIconColor(
            safeRanges,
            safeRangeKeys?.BLOODPRESSURESYSTOLIC,
            vitals?.bp?.[0]?.sp
          )}
        />
      ),
      time: vitals?.bp?.[0]?.t
        ? getLocalTimeFromEpoch(parseInt(vitals?.bp?.[0]?.t))
        : '-',
      details: false,
    },
    {
      name: 'Blood Pressure Diastolic',
      subName: 'Hyper Tension',
      value: vitals?.bp?.[0]?.dp || '-',
      unit: 'mm Hg',
      note: `Normal Range is ${
        safeRanges?.[safeRangeKeys?.BLOODPRESSUREDIASTOLIC]?.min
      }-${safeRanges?.[safeRangeKeys?.BLOODPRESSUREDIASTOLIC]?.max} mmHg`,
      icon: (
        <BloodPressureIcon
          height={40}
          width={40}
          color={getIconColor(
            safeRanges,
            safeRangeKeys?.BLOODPRESSUREDIASTOLIC,
            vitals?.bp?.[0]?.dp
          )}
        />
      ),
      time: vitals?.bp?.[0]?.t
        ? getLocalTimeFromEpoch(parseInt(vitals?.bp?.[0]?.t))
        : '-',
      details: false,
    },
    {
      name: 'Heart Rate Variability',
      subName: 'Current',
      value: `${vitals?.hrv?.[0]?.v || '-'}`,
      unit: 'ms',
      note: `Normal Range is ${
        safeRanges?.[safeRangeKeys?.HEARTRATEVAR]?.min
      }-${safeRanges?.[safeRangeKeys?.HEARTRATEVAR]?.max} ms`,
      icon: (
        <HeartIcon
          height={40}
          width={40}
          color={getIconColor(
            safeRanges,
            safeRangeKeys?.HEARTRATEVAR,
            vitals?.hrv?.[0]?.v
          )}
        />
      ),
      time: vitals?.hrv?.[0]?.t
        ? getLocalTimeFromEpoch(parseInt(vitals?.hrv?.[0]?.t))
        : '-',
      details: false,
    },
    {
      name: 'Skin Temperature',
      subName: 'Current',
      value: `${vitals?.skt?.[0]?.v || '-'}`,
      unit: '°F',
      note: `Normal Range is ${
        safeRanges?.[safeRangeKeys?.SKINTEMPERATURE]?.min
      }-${safeRanges?.[safeRangeKeys?.SKINTEMPERATURE]?.max} °F`,
      icon: (
        <SkinIcon
          height={40}
          width={40}
          color={getIconColor(
            safeRanges,
            safeRangeKeys?.SKINTEMPERATURE,
            vitals?.skt?.[0]?.v
          )}
        />
      ),
      time: vitals?.skt?.[0]?.t
        ? getLocalTimeFromEpoch(parseInt(vitals?.skt?.[0]?.t))
        : '-',
      details: false,
    },
    {
      name: 'Respiratory Rate',
      subName: 'Current',
      value: `${vitals?.rr?.[0]?.v || '-'}`,
      unit: 'Breaths/Min',
      note: `Normal Range is ${
        safeRanges?.[safeRangeKeys?.RESPIRATORYRATE]?.min
      }-${safeRanges?.[safeRangeKeys?.RESPIRATORYRATE]?.max} Breaths/Min`,
      icon: (
        <LungIcon
          height={40}
          width={40}
          color={getIconColor(
            safeRanges,
            safeRangeKeys?.RESPIRATORYRATE,
            vitals?.rr?.[0]?.v
          )}
        />
      ),
      time: vitals?.rr?.[0]?.t
        ? getLocalTimeFromEpoch(parseInt(vitals?.rr?.[0]?.t))
        : '-',
      details: false,
    },
  ]

  const handleCardClick = (selectedVital: string) => {
    setOpenDrawer((prevData: boolean) => !prevData)
    setSelectedVital(selectedVital)
  }

  return (
    <div>
      <Grid container direction={'row'} rowGap={3} spacing={1.5}>
        <Grid item xs={12}>
          <Box pt={2}>
            <ECGChart ecgData={ecgData} />
          </Box>
        </Grid>
        {cardData?.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} lg={4} xl={2} key={index}>
            <VitalCard
              name={item?.name}
              subName={item?.subName}
              value={item?.value}
              unit={item?.unit}
              note={item?.note}
              icon={item?.icon}
              details={item?.details}
              timeStamp={item?.time}
              onClick={() => handleCardClick(item?.name)}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

export default Prorithm
